<div>
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="approvedSpecialistsByTopic()"></grid-content>
</div>